<template>
    <div class="content">
        <div class="index-page">
            <car-headerbar title="呱呱问卷" />
            <ul class="wrap">
                <li class="item" @click="jump('mine')">
                    <div class="background_item" style="background-image:url(https://image-pub.guazistatic.com/qnbdp1066xba4c3f7238db464488c8fa41bb68880e1723778709.png)">
                        <div class="flex">
                            <div class="flex_row">
                                <img src="https://image-pub.guazistatic.com/qnbdp1066x5c4aed9d9a6f42109e24f49a609147171723795990.png" alt="" class="img_icon">
                                <div class="title">我的问卷</div>
                                <img src="https://image-pub.guazistatic.com/qnbdp1066xa011627abb4b4ea08377776914a362231723780679.png" alt="" class="img_left">
                            </div>
                            <div class="flex_row">
                                <span class="count_title">问卷数量</span>
                                <div class="count">{{pageCount}}</div>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="item" @click="jump('template')">
                    <div class="background_item" style="background-image:url(https://image-pub.guazistatic.com/qnbdp1066x1bd4e56281e945a8a9c4e43afa9e1e251723778761.png)">
                        <div class="flex">
                            <div class="flex_row">
                                <img src="https://image-pub.guazistatic.com/qnbdp1066xf2c4150d41df49e9bacd2aa96fea29bd1723787518.png" alt="" class="img_icon">
                                <div class="title">模版中心</div>
                                <img src="https://image-pub.guazistatic.com/qnbdp1066xa011627abb4b4ea08377776914a362231723780679.png" alt="" class="img_left">
                            </div>
                            <div class="flex_row">
                                <span class="count_title">模版数量</span>
                                <div class="count">{{templateCount}}</div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>

</template>
<script>
import { Questionnaire } from '@/network'
import { mixin } from '@/mixins'
import { removeClass2 } from '@/util/status-util'
import browser from '@/util/browser'
import NativeApi from 'native-api'

export default {
    name: 'index-page',
    data() {
        return {
            pageCount: '',
            templateCount: ''
        }
    },
    mixin: [mixin],
    created() {
        this.getData()
    },
    methods: {
        jump(name) {
            if (name === 'template') {
                this.$store.commit('updateCreateTemplateTitle', '模版中心')
            }
            const { guaguaApp: isApp } = browser
            let pageRoute = this.$router.resolve({
                name,
            })
            if (isApp) {
                NativeApi.invoke('createWebView', { url: `${location.href.split('#')[0]}${pageRoute.href}` })
                return
            }
            this.$router.push({name})
        },
        getData() {
            const params = {
                tid: this.tid
            }
            Questionnaire.getData(params).then(res => {
                removeClass2('body', 'loading')
                const { data: { data: { pageCount, templateCount} } } = res
                this.pageCount = pageCount
                this.templateCount = templateCount
            })
        }
    }
}
</script>
<style scoped  lang="scss">
.flex {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .img_icon {
        margin-left: 11px;
        width: 59px;
        height: 59px;
    }
    .img_left {
        margin-left: 4px;
        width: 8px;
        height: 9px;
    }
    .title {
        font-weight: 600;
        font-size: 17px;
        color: #333333;
        line-height: 17px;
    }
}
.wrap {
    display: flex;
    flex-direction: column;
    padding:16px 12px 20px;
    .item{
        height: 97px;
        text-align: center;
        border-radius: 5px;
        font-size: 14px;
        margin-bottom: 8px;
        background-color: #fff;
    }
    .background_item {
        height: 100%;
        background-repeat: no-repeat;
        background-size: contain;
    }
}
.index-page {
    background: url(https://image-pub.guazistatic.com/qnbdp1066xa355ac6248f74e0eb0d02dee2c2ce9f51723777747.png);
    background-repeat: no-repeat;
    background-size: cover;
    height: 100%;
}

.content {
    height: 100%;
    width: 100%;
    background: #F2F4F6;
}
.flex_row {
    display: flex;
    align-items: center;
}
.count {
    margin-right: 28px;
    font-weight: 600;
    font-size: 20px;
    color: #06B455;
    line-height: 20px;
    text-align: right;
}
.count_title {
    margin-right: 8px;
    font-weight: 400;
    font-size: 13px;
    color: #9298A8;
    line-height: 13px;
    text-align: left;
    font-style: normal;
}
</style>